const event = {
  payoutEvent: 'PayoutEvent',
  payoutRefundEvent: 'PayoutRefundEvent'
};

module.exports = event;
